import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Mixpanel from "mixpanel-browser";
import tagCross from "../../assets/images/tag-cross.svg";
import edit from "../../assets/images/edit.svg";
import moredownicon from "../../assets/images/moredown-icn.svg";
import removelableicn from "../../assets/images/remove-labl-icn.svg";
import textticon from "../../assets/images/text-ticon.svg";
import arrowright from "../../assets/images/arrow-right.svg";
import { labelListing } from "../../features/user-document/label-listing";
import { getColoroCode, RoleRightsForModule } from "../../utils/utils";
import { updateLabel } from "../../features/user-document/updateLabelSlice";
import { OK } from "../../constants/statusCode";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { getSingleLabel } from "../../features/user-document/getSingleLabelSlice";
import Loader from "../../common/loader/Loader";
import { useDrag } from "react-dnd";
import { labelDocument } from "../../features/user-document/labelDocumentSaveSlice";

const LabelSubMenu = ({
  setSubCategories,
  perPage,
  currentPage,
  setCurrentModal,
  setLabelId,
  labelDeteleToggel,
  setSelectedLabel,
  setSelectedCheckbox,
  label,
  selectedRowsID
}) => {

  const { isUpdateLabelLoding } = useSelector((state) => ({
    isUpdateLabelLoding: state?.updateLabelSlice?.isLoading
  }));

  let dispatch = useDispatch();
  let projectData = JSON.parse(localStorage.getItem("_user"));

  // useEffect(() => {
  //   dispatch(labelListing(projectData?.projects[0]?.uuid));
  // }, []);

  const colorArray = [
    { colorName: "color-gray" },
    { colorName: "color-cyan" },
    { colorName: "color-light-purple" },
    { colorName: "color-light-pink" },
    { colorName: "color-dark-blue" },
    { colorName: "color-dark-cyan" },
    { colorName: "color-dark-purple" },
    { colorName: "color-dark-pink" },
    { colorName: "color-dark-yellow" },
    { colorName: "color-light-yellow" },
    { colorName: "color-saffron" },
    { colorName: "color-dark-red" },
    { colorName: "color-dark-green" },
    { colorName: "color-dark-green2" },
    { colorName: "color-light-green" },
    { colorName: "color-light-green2" },
  ];

  const handleColorChange = async (color, uuid) => {
    let payloadData = await dispatch(getSingleLabel(uuid));
    let newObj = {};
    if (payloadData?.payload?.data?.responseData?.label?.ParentSubLabel) {
      newObj.parent_uuid = payloadData?.payload?.data?.responseData?.label?.ParentSubLabel?.uuid;
    }
    Mixpanel.track("label color changed", {
      Page: "Label color menu",
    });
    let colorCode = getColoroCode(color);
    newObj.color_hex = colorCode;
    const { payload } = await dispatch(updateLabel({ id: uuid, body: newObj }));
    if (payload.status === OK) {
      dispatch(
        getDocuments({
          perPage: perPage,
          page: currentPage,
          project_uuid: projectData?.projects[0]?.uuid,
        }));
      dispatch(labelListing(projectData?.projects[0]?.uuid));
    }
  }

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'TABLE_CELL',
    item: { label },
    end: async (item, monitor) => {
      const dropResult = monitor.getDropResult()
      // if (item && dropResult) {
      //   let uuidArray = [];
      //   let selectedLabelId = [item.label.uuid];
      //   if (dropResult?.selectedRowsID?.filter(d => d?.original?.uuid == dropResult?.uuid)?.length) {
      //     dropResult?.selectedRowsID.map((data) => {
      //       uuidArray.push(data?.original?.uuid);
      //     });
      //   }
      //   else{
      //     uuidArray.push(dropResult.uuid)
      //   }
      //   let { payload } = await dispatch(
      //     labelDocument({ document_uuid: uuidArray, label_uuid: selectedLabelId })
      //   );
      //   if (payload.status === 201) {
      //     dispatch(
      //       getDocuments({
      //         perPage: perPage,
      //         page: currentPage,
      //         project_uuid: projectData?.projects[0]?.uuid,
      //         // search: searchValue,
      //       })
      //     );
      //   }
      // }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }))
  const opacity = isDragging ? 0.4 : 1

  useEffect(() => {
    if (isDragging) document.body.style.cursor = 'grab !important';
    else document.body.style.cursor = 'grab !important';
  }, [isDragging]);

  return (
    <>
      {isUpdateLabelLoding ? <Loader /> :
        <>
          <div ref={drag} style={{ cursor: isDragging ? 'grab' : 'grab', opacity }} data-testid={`box`} className="d-flex align-items-center cmnlin-link">
            <div className="main-category">
              {/* <img
                        className="lang-cmn-icn"
                        src={tagCrossfill}
                        alt="fileicn"
                    /> */}
              <svg id="tag-cross" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path id="Vector" d="M9.767,13.75h-5.6A4.168,4.168,0,0,1,0,9.583V4.167A4.168,4.168,0,0,1,4.167,0h5.6A4.148,4.148,0,0,1,12.85,1.367L15.792,4.6a3.377,3.377,0,0,1,0,4.55L12.85,12.383A4.148,4.148,0,0,1,9.767,13.75Z" transform="translate(1.667 3.125)" fill={`#${label?.color_hex}`} stroke={`#${label?.color_hex}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
                <path id="Vector-2" data-name="Vector" d="M20,0H0V20H20Z" fill="none" opacity="0" />
              </svg>

              <p>{label?.name.length > 10 ? label.name.slice(0, 15) + '...' : label?.name}</p>
            </div>
            <div className="dropdown action-dropdown">
              <button
                className="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src={moredownicon} alt="" />
              </button>
              <ul className="dropdown-menu">
                <li className="dropdown-item sub-level-menu-item mt-1">
                  <span>
                    <img
                      className="trnsfomr user-table-drow-img action-img"
                      src={textticon}
                      alt=""
                    />
                  </span>
                  Label color
                  <img className="arrow-right" src={arrowright} alt="" />
                  <div className="color-picker-ul-main">
                    <ul className="color-picker-ul row">
                      {colorArray.map((data, index) => {
                        return (
                          <li className="color-picker-li" key={index}>
                            <span
                              className={`color-span ${data.colorName}`}
                              onClick={() => {
                                handleColorChange(data.colorName, label.uuid);
                              }}
                            ></span>
                          </li>
                        );
                      })}
                      {/* <li className="color-picker-li"><span className="color-span color-gray"></span></li>
                              <li className="color-picker-li"><span className="color-span color-cyan"></span></li>
                              <li className="color-picker-li"><span className="color-span color-light-purple"></span></li>
                              <li className="color-picker-li"><span className="color-span color-light-pink"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-blue"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-cyan"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-purple"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-pink"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-yellow"></span></li>
                              <li className="color-picker-li"><span className="color-span color-light-yellow"></span></li>
                              <li className="color-picker-li"><span className="color-span color-saffron"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-red"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-green"></span></li>
                              <li className="color-picker-li"><span className="color-span color-dark-green2"></span></li>
                              <li className="color-picker-li"><span className="color-span color-light-green"></span></li>
                              <li className="color-picker-li"><span className="color-span color-light-green2"></span></li> */}
                    </ul>
                  </div>
                </li>

                {RoleRightsForModule("Update","Labels") &&
                <li
                  className="dropdown-item mt-1"
                  onClick={() => {
                    setCurrentModal("editLabelModal");
                    setLabelId(label.uuid);
                  }}
                >
                  <span>
                    <img className="action-img" src={edit} alt="" />
                  </span>
                  Edit
                </li>}
                {RoleRightsForModule("Add","Labels") &&
                <li
                  className="dropdown-item mt-1"
                  onClick={() => {
                    setCurrentModal("labelModal");
                    //setLabelId(label.uuid);
                    setSelectedLabel(label.uuid)
                    setSelectedCheckbox(true);
                  }}
                >
                  <span>
                    <img className="action-img" src={tagCross} alt="" />
                  </span>
                  Add sublabel
                </li>}
                {/* <li className="dropdown-item mt-1">
                          <span>
                            <img
                              className="action-img"
                              src={removelableicn}
                              alt=""
                            />
                          </span>
                          Remove label
                        </li> */}
                {RoleRightsForModule("Delete","Labels") &&
                <li
                  className="dropdown-item mt-1"
                  onClick={() => {
                    labelDeteleToggel();
                    setCurrentModal("labelDeleteModal");
                    setLabelId(label?.uuid);
                    setSubCategories('Documents')
                  }}
                >
                  <span>
                    <img className="action-img" src={removelableicn} alt="" />
                  </span>
                  Remove label
                </li>}
              </ul>
            </div>
          </div>
          <div style={{ marginLeft: 20 }}>
            {/* <div style={{ fontWeight: "bold" }}>{label?.name}</div> */}
            {label?.SubLabel && (
              <div style={{ marginTop: 10 }}>
                {label?.SubLabel.map((child, index) => (
                  <LabelSubMenu
                    key={index}
                    label={child}
                    setSubCategories={setSubCategories}
                    setCurrentModal={setCurrentModal}
                    setLabelId={setLabelId}
                    labelDeteleToggel={labelDeteleToggel}
                    setSelectedLabel={setSelectedLabel}
                    setSelectedCheckbox={setSelectedCheckbox}
                  />
                ))}
              </div>
            )}
          </div>
        </>
      }
    </>
  );
};

export default LabelSubMenu;
